/**
 * This file is auto-generated. Any modifications will be
 * overwritten by the generate-icon npm script.
 */
import React from 'react';
import { SvgIcon } from "../shared/SvgIcon";
var StudentFillIcon = function StudentFillIcon(props) {
  return /*#__PURE__*/React.createElement(SvgIcon, props, /*#__PURE__*/React.createElement("path", {
    d: "M19 13.18V17.18L13.4371 20.2158C12.5414 20.7046 11.4586 20.7046 10.5629 20.2158L5 17.18V13.18L12 17L19 13.18ZM10.5634 3.78358C11.4589 3.29516 12.5411 3.29516 13.4366 3.78358L21.3905 8.1221C22.0854 8.50112 22.0854 9.49888 21.3905 9.8779L12 15L3 10.09V17H1V10.1873C1 9.45538 1.39977 8.78194 2.0423 8.43148L10.5634 3.78358Z"
  }));
};
export default StudentFillIcon;